import { SvgIcon } from '@cinch-labs/design-system'
import { useVehicleGallery, useModal } from '../../hooks'
import styles from './media.module.css'
import { getStoryblokImageServiceUrl } from '@cinch-nx/data-storyblok'

export interface MediaProps {
  imageCount: number
  imageSrc: string
  title?: string
  alt: string | undefined
}

export const Media = ({ imageCount, imageSrc, title, alt }: MediaProps) => {
  const { open } = useModal()
  const { setImageIndex, imageIndexes } = useVehicleGallery()

  const getImageIndex = () => {
    switch (title) {
      case 'Interior': {
        return imageIndexes?.interiorSectionImageIndex || 0
      }
      case 'Performance': {
        return imageIndexes?.performanceSectionImageIndex || 0
      }
      case 'Practicality': {
        return imageIndexes?.practicalitySectionImageIndex || 0
      }
      case 'Running costs': {
        return imageIndexes?.runningCostsSectionImageIndex || 0
      }
      default: {
        return 0
      }
    }
  }

  const handleClick = async () => {
    if (title) {
      await setImageIndex(getImageIndex())
    }
    open()
  }

  return (
    <div className={styles.mediaContainer}>
      {imageSrc && (
        <button onClick={handleClick}>
          <img
            src={getStoryblokImageServiceUrl(imageSrc, {
              filters: [{ quality: 80 }],
            })}
            alt={alt}
            className={styles.mediaImage}
          />
          <span className={styles.mediaImageInfo}>
            <SvgIcon name="gallery" />
            Gallery ({imageCount})
          </span>
        </button>
      )}
    </div>
  )
}
